import React from "react";
import "../styles/Contact.css";


const Contact = () => {
  return (
    <section className="contact">

      <div className="contact-box">

        <h2>
          Contact Me
        </h2>


        <p>
          I'm always open to discussing new projects,
          ideas and opportunities.
        </p>


        <div className="contact-info">


          <a href="mailto:hoomankhodadadi91@gmail.com">
            📧 hoomankhodadadi91@gmail.com
          </a>


          <a href="tel:+989046034275">
            📱 +98 904 603 4275
          </a>


        </div>


      </div>

    </section>
  );
};


export default Contact;